import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/mail_gray_60.png'
import _imports_1 from '@/assets/icons/megaphone.svg'
import _imports_2 from '@/assets/logos/Sync_app.png'
import _imports_3 from '@/assets/logos/Facebook.png'
import _imports_4 from '@/assets/logos/Discord.svg'


const _withScopeId = n => (_pushScopeId("data-v-b156bf92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "support-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Support", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "We're here to help!", -1))
const _hoisted_4 = { class: "list-unstyled help" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-icon",
  src: _imports_0
}, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Downloads", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Sync app", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Community", -1))
const _hoisted_12 = { class: "list-unstyled resources" }
const _hoisted_13 = { class: "facebook" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_15 = { class: "no-break" }
const _hoisted_16 = { class: "discord" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_18 = { class: "no-break" }

import { usePageTitle } from '@webapp/util/AppUtil'
import { ExternalLinkIcon } from '@zhuowenli/vue-feather-icons'
import { useTokenManager } from '@/auth/TokenManager'
import { exchangeTokenAsync } from '@/auth/LocalTokenApi'
import { trackClick } from '@/util/Analytics'


export default /*#__PURE__*/_defineComponent({
  __name: 'SupportPage',
  setup(__props) {

const tokenManager = useTokenManager()

usePageTitle("Support")

function onFeedbackClick() {
  trackClick('support_feedback', { section: 'contact', id: 'support_feedback', target: 'https://treecrossing.sleekplan.app' })
  void onFeedback()
}

async function onFeedback() {
  const userToken = tokenManager.current.token
  try {
    const sleekToken = await exchangeTokenAsync(userToken, "https://app.sleekplan.com", '')
    const sleekUrl = `https://treecrossing.sleekplan.app/?sso=${encodeURIComponent(sleekToken.access_token)}`

    const popup = window.open(sleekUrl, '_blank', 'noopener')
    if (!popup) {
      window.location.assign(sleekUrl)
    }
  } catch {
    // No-op: if token exchange fails, remain on current page.
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "btn btn-choice contact"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Contact us ")
          ]),
          _: 1
        })
      ]),
      (_unref(tokenManager).current.isValid)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-choice feedback",
              onClick: onFeedbackClick
            }, [
              _hoisted_7,
              _createTextVNode(" Feedback ")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_router_link, { to: { name: 'faq' } }, {
      default: _withCtx(() => [
        _createTextVNode(" Frequently Asked Questions ")
      ]),
      _: 1
    }),
    _hoisted_8,
    _createVNode(_component_router_link, {
      to: "/syncapp",
      class: "btn btn-link link-dark syncapp"
    }, {
      default: _withCtx(() => [
        _hoisted_9,
        _hoisted_10
      ]),
      _: 1
    }),
    _hoisted_11,
    _createElementVNode("ul", _hoisted_12, [
      _createElementVNode("li", _hoisted_13, [
        _createElementVNode("a", {
          href: "https://www.facebook.com/groups/1484810245417258",
          target: "_blank",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(trackClick)('support_community_facebook', { section: 'community', id: 'community_facebook', target: 'https://www.facebook.com/groups/1484810245417258' })))
        }, [
          _hoisted_14,
          _createTextVNode(" Facebook "),
          _createElementVNode("span", _hoisted_15, [
            _createTextVNode("Group "),
            _createVNode(_unref(ExternalLinkIcon), { size: "0.9x" })
          ])
        ])
      ]),
      _createElementVNode("li", _hoisted_16, [
        _createElementVNode("a", {
          href: "https://discord.gg/mFkGM5fH7b",
          target: "_blank",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(trackClick)('support_community_discord', { section: 'community', id: 'community_discord', target: 'https://discord.gg/mFkGM5fH7b' })))
        }, [
          _hoisted_17,
          _createElementVNode("div", null, [
            _createTextVNode("Discord "),
            _createElementVNode("span", _hoisted_18, [
              _createTextVNode("Server "),
              _createVNode(_unref(ExternalLinkIcon), { size: "0.9x" })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})